import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import cooperation from '../views/cooperation.vue'
import Joinus from '../views/Joinus.vue'


const routes = [
	{
		// 首页
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		// 合作与生态
		path: '/cooperation',
		name: 'cooperation',
		component: () => import('../views/cooperation.vue'),
	},
	{
		// 加入我们
		path: '/Joinus',
		name: 'Joinus',
		component: () => import('../views/Joinus.vue'),
	},
	{
		// 关于我们
		path: '/about',
		name: 'about',
		component: () => import('../views/aboutUs/AboutView.vue'),
	},
	{
		// 团队与荣誉
		path: '/about/teamHonor',
		name: 'teamHonor',
		component: () => import('../views/aboutUs/teamHonor.vue'),
	},
	{
		// 发展历程
		path: '/about/developmentHistory',
		name: 'developmentHistory',
		component: () => import('../views/aboutUs/developmentHistory.vue'),
	},
	{
		// 企业规划
		path: '/about/plan',
		name: 'plan',
		component: () => import('../views/aboutUs/plan.vue'),
	},
	{
		// 联合动态
		path: '/news',
		name: 'news',
		component: () => import('../views/news/news.vue')
	},
	{
		// 联合动态.更多动态
		path: '/news/newsList',
		name: 'newsList',
		component: () => import('../views/news/newsList.vue')
	},
	{
		// 联合动态.新闻详情
		path: '/news/newsDetail',
		name: 'newsDetail',
		component: () => import('../views/news/newsDetail.vue')
	},
	{
		// 主营业务
		path: '/business',
		name: 'business',
		component: () => import('../views/business')
	},
	{
		// 投资者关系
		path: '/investor',
		name: 'investor',
		component: () => import('../views/investor')
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router
